import styled from "styled-components";
import { FC } from "react";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";

import { Td } from "@/components/Table";
import Text from "@/components/Text";
import { TestingCompetitionBonusResource } from "@/types/resources";
import { RootState } from "@/utils/store";
import ProjectsSequenceBadge from "@/pages/GamificationProjects/components/ProjectsSequenceBadge";

const StyledText = styled(Text)`
  margin-top: 4px;
  display: inline-block;
`;

const Bonus = styled.div`
  display: flex;
  align-items: center;
`;

const Dot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.success};
  margin-right: 8px;
`;

const TeamIcon = styled.img`
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 16px;
  height: 16px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 6px;
`;

const TeamInfo = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  bonus: TestingCompetitionBonusResource;
}

const ApprovedBonusesTableRow: FC<Props> = ({ bonus }) => {
  const teamIcon = useSelector(
    (state: RootState) => state.teams[bonus.teamId].icon?.versions?.icon
  );

  return (
    <tr>
      <Td>
        {bonus.projectName}
        <br />
        <StyledText $type="extraSmall" $color="gray" as="span">
          {bonus.projectId}
        </StyledText>
      </Td>
      <Td>
        <TeamInfo>
          {!!teamIcon && (
            <TeamIcon src={teamIcon} alt={`${bonus.teamName} icon`} />
          )}
          {bonus.teamName}
        </TeamInfo>
      </Td>
      <Td>
        <ProjectsSequenceBadge testSequence={bonus.cBatch} />
      </Td>
      <Td>
        {DateTime.fromISO(bonus.endedAt).toRelative()}
        <br />
        <StyledText $type="extraSmall" $color="gray" as="span">
          {DateTime.fromISO(bonus.endedAt).toFormat("yyyy/LL/dd")}
        </StyledText>
      </Td>
      <Td>
        {DateTime.fromISO(bonus.approved_at).toRelative()}
        <br />
        <StyledText $type="extraSmall" $color="gray" as="span">
          {DateTime.fromISO(bonus.approved_at).toFormat("yyyy/LL/dd")}
        </StyledText>
      </Td>
      <Td>{bonus.userName}</Td>
      <Td>{bonus.ctr} %</Td>
      <Td>
        <Bonus>
          <Dot />€ {bonus.reward}
        </Bonus>
      </Td>
    </tr>
  );
};

export default ApprovedBonusesTableRow;
